export default __webpack_public_path__ + "img/servicesbg.55f4f384.jpg";